import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import { DefaultApiClient } from '@internal/backstage-plugin-devops-react';
import {
  AlertsStatisticsResponse,
  SpmAlertInfo,
} from '@internal/backstage-plugin-devops-spm-common';
import { SpmApi } from './SpmApi';

export class SpmApiClient extends DefaultApiClient implements SpmApi {
  public constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    super({
      backendName: 'devops-spm',
      ...options,
    });
  }

  async getAlertStatistics(
    accountId: string,
    lastDays: number,
    compression: number,
    types: string[],
  ): Promise<[AlertsStatisticsResponse[], string]> {
    const parameters =
      `?accountId=${encodeURIComponent(accountId)}` +
      `&lastDays=${encodeURIComponent(lastDays)}` +
      `&compression=${encodeURIComponent(compression)}` +
      `&types=${encodeURIComponent(types.join('+'))}`;
    const urlSegment = `v1/get-alert-statistics${parameters}`;

    const response = await this.get(urlSegment);
    const body = await response.body;

    return [body.items, body.notification];
  }

  async getRecentAlerts(
    accountId: string,
    count: number,
  ): Promise<SpmAlertInfo[]> {
    const urlSegment =
      `v1/get-recent-alerts?` +
      `accountId=${encodeURIComponent(accountId)}&count=${encodeURIComponent(
        count,
      )}`;

    const response = await this.get(urlSegment);
    const body = await response.body;

    return body.items;
  }
}
